import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=5b7e3bc6&scoped=true&"
import script from "./SignDialog.vue?vue&type=script&lang=ts&"
export * from "./SignDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SignDialog.vue?vue&type=style&index=0&id=5b7e3bc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e3bc6",
  null
  
)

export default component.exports